"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSimpleConditional = exports.isLegacyConditional = exports.isJSONConditional = void 0;
exports.conditionallyHidden = conditionallyHidden;
exports.checkCustomConditional = checkCustomConditional;
exports.checkLegacyConditional = checkLegacyConditional;
exports.checkJsonConditional = checkJsonConditional;
exports.convertShowToBoolean = convertShowToBoolean;
exports.checkSimpleConditional = checkSimpleConditional;
const lodash_1 = require("lodash");
const formUtil_1 = require("./formUtil");
const operators_1 = __importDefault(require("./operators"));
const utils_1 = require("./utils");
const isJSONConditional = (conditional) => {
    return conditional && conditional.json && (0, lodash_1.isObject)(conditional.json);
};
exports.isJSONConditional = isJSONConditional;
const isLegacyConditional = (conditional) => {
    return conditional && conditional.when;
};
exports.isLegacyConditional = isLegacyConditional;
const isSimpleConditional = (conditional) => {
    return conditional && conditional.conjunction && conditional.conditions;
};
exports.isSimpleConditional = isSimpleConditional;
function conditionallyHidden(context) {
    const { scope, path } = context;
    if (scope.conditionals && path) {
        const hidden = (0, lodash_1.find)(scope.conditionals, (conditional) => {
            return conditional.path === path;
        });
        return hidden === null || hidden === void 0 ? void 0 : hidden.conditionallyHidden;
    }
    return false;
}
/**
 * Check custom javascript conditional.
 *
 * @param component
 * @param custom
 * @param row
 * @param data
 * @returns {*}
 */
function checkCustomConditional(condition, context, variable = 'show') {
    if (!condition) {
        return null;
    }
    const value = (0, utils_1.evaluate)(condition, context, variable);
    if (value === null) {
        return null;
    }
    return value;
}
/**
 * Checks the legacy conditionals.
 *
 * @param conditional
 * @param context
 * @param checkDefault
 * @returns
 */
function checkLegacyConditional(conditional, context) {
    const { data, form, paths, local } = context;
    if (!conditional || !(0, exports.isLegacyConditional)(conditional) || !conditional.when) {
        return null;
    }
    const value = (0, formUtil_1.getComponentValue)(form, data, conditional.when, paths === null || paths === void 0 ? void 0 : paths.dataIndex, local);
    const eq = String(conditional.eq);
    const show = String(conditional.show);
    if ((0, lodash_1.isObject)(value) && (0, lodash_1.has)(value, eq)) {
        return String(value[eq]) === show;
    }
    if (Array.isArray(value) && value.map(String).includes(eq)) {
        return show === 'true';
    }
    return (String(value) === eq) === (show === 'true');
}
/**
 * Checks the JSON Conditionals.
 * @param conditional
 * @param context
 * @returns
 */
function checkJsonConditional(conditional, context) {
    if (!conditional || !(0, exports.isJSONConditional)(conditional)) {
        return null;
    }
    return (0, utils_1.evaluate)(conditional.json, context);
}
/**
 * Convert the 'show' property of simple conditional to boolean
 * @param show
 * @returns {boolean}
 */
function convertShowToBoolean(show) {
    let shouldShow = show;
    if ((0, lodash_1.isString)(show)) {
        try {
            shouldShow = JSON.parse(show);
        }
        catch (e) {
            console.log(e);
            shouldShow = show;
        }
    }
    return !!shouldShow;
}
/**
 * Checks the simple conditionals.
 * @param conditional
 * @param context
 * @returns
 */
function checkSimpleConditional(conditional, context) {
    const { component, data, instance, form, paths, local } = context;
    if (!conditional || !(0, exports.isSimpleConditional)(conditional)) {
        return null;
    }
    const { conditions = [], conjunction = 'all', show = true } = conditional;
    if (!conditions.length) {
        return null;
    }
    const conditionsResult = (0, lodash_1.filter)((0, lodash_1.map)(conditions, (cond) => {
        const { operator } = cond;
        const { value: comparedValue, component: conditionComponentPath } = cond;
        if (!conditionComponentPath) {
            // Ignore conditions if there is no component path.
            return null;
        }
        const formComponents = (form === null || form === void 0 ? void 0 : form.components) || [];
        const conditionComponent = (0, formUtil_1.getComponent)(formComponents, conditionComponentPath, true, paths === null || paths === void 0 ? void 0 : paths.dataIndex);
        const value = conditionComponent
            ? (0, formUtil_1.getComponentValue)(form, data, conditionComponentPath, paths === null || paths === void 0 ? void 0 : paths.dataIndex, local)
            : null;
        const ConditionOperator = operators_1.default[operator];
        return ConditionOperator
            ? new ConditionOperator().getResult({
                value,
                comparedValue,
                instance,
                component,
                conditionComponent,
                conditionComponentPath,
                data,
            })
            : true;
    }), (res) => res !== null);
    let result = false;
    switch (conjunction) {
        case 'any':
            result = (0, lodash_1.some)(conditionsResult, (res) => !!res);
            break;
        default:
            result = (0, lodash_1.every)(conditionsResult, (res) => !!res);
    }
    return convertShowToBoolean(show) ? result : !result;
}
